import { Dribbble, Target, Zap, CircleDot, Circle, Disc, Swords, Dumbbell, Heart, Music, Flame, Shield } from "lucide-react";

export const ALL_SPORTS = [
  // Court Sports
  { value: "basketball", label: "Basketball", icon: Dribbble, category: "court" },
  { value: "badminton", label: "Badminton", icon: Target, category: "court" },
  { value: "pickleball", label: "Pickleball / Padel", icon: Zap, category: "court" },
  { value: "volleyball", label: "Volleyball", icon: CircleDot, category: "court" },
  { value: "tennis", label: "Tennis", icon: Disc, category: "court" },
  { value: "table-tennis", label: "Table Tennis", icon: Disc, category: "court" },
  { value: "football", label: "Football (Soccer)", icon: CircleDot, category: "court" },
  { value: "billiards", label: "Billiards", icon: Circle, category: "court" },
  { value: "sepak-takraw", label: "Sepak Takraw", icon: Circle, category: "court" },
  { value: "arnis", label: "Arnis / Eskrima", icon: Swords, category: "court" },
  // Fitness & Gym
  { value: "fitness", label: "Fitness / Gym", icon: Dumbbell, category: "fitness" },
  { value: "crossfit", label: "CrossFit", icon: Flame, category: "fitness" },
  { value: "boxing", label: "Boxing", icon: Shield, category: "fitness" },
  { value: "swimming", label: "Swimming", icon: Circle, category: "fitness" },
  // Yoga & Wellness
  { value: "yoga", label: "Yoga", icon: Heart, category: "wellness" },
  { value: "pilates", label: "Pilates", icon: Heart, category: "wellness" },
  { value: "meditation", label: "Meditation", icon: Heart, category: "wellness" },
  // Dance
  { value: "dance", label: "Dance", icon: Music, category: "dance" },
  { value: "ballet", label: "Ballet", icon: Music, category: "dance" },
  { value: "hiphop", label: "Hip-Hop", icon: Music, category: "dance" },
  { value: "kpop", label: "K-Pop Dance", icon: Music, category: "dance" },
];

export const SPORT_COLORS = {
  basketball: "bg-orange-100 text-orange-700",
  badminton: "bg-blue-100 text-blue-700",
  pickleball: "bg-green-100 text-green-700",
  volleyball: "bg-yellow-100 text-yellow-700",
  billiards: "bg-emerald-100 text-emerald-700",
  tennis: "bg-lime-100 text-lime-700",
  "table-tennis": "bg-sky-100 text-sky-700",
  football: "bg-indigo-100 text-indigo-700",
  "sepak-takraw": "bg-rose-100 text-rose-700",
  arnis: "bg-red-100 text-red-700",
  fitness: "bg-red-100 text-red-700",
  crossfit: "bg-amber-100 text-amber-700",
  boxing: "bg-slate-100 text-slate-700",
  swimming: "bg-cyan-100 text-cyan-700",
  yoga: "bg-pink-100 text-pink-700",
  pilates: "bg-fuchsia-100 text-fuchsia-700",
  meditation: "bg-violet-100 text-violet-700",
  dance: "bg-purple-100 text-purple-700",
  ballet: "bg-pink-100 text-pink-700",
  hiphop: "bg-zinc-100 text-zinc-700",
  kpop: "bg-rose-100 text-rose-700",
};

export const SPORT_CATEGORIES = [
  { key: "court", label: "Court Sports" },
  { key: "fitness", label: "Fitness & Gym" },
  { key: "wellness", label: "Yoga & Wellness" },
  { key: "dance", label: "Dance" },
];

export function getSportLabel(value) {
  return ALL_SPORTS.find(s => s.value === value)?.label || value;
}

export function getSportColor(value) {
  return SPORT_COLORS[value] || "bg-slate-100 text-slate-700";
}

export function getSportCategory(value) {
  return ALL_SPORTS.find(s => s.value === value)?.category || "court";
}
